import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPayments = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M10.5 18.83v-.404l-.396-.085c-1.615-.345-2.907-1.277-3.219-2.841h1.212c.129.525.401 1.01.87 1.384.592.471 1.435.716 2.533.716 1.184 0 1.995-.295 2.514-.766a2.05 2.05 0 00.686-1.524c0-.573-.162-1.168-.72-1.693-.53-.499-1.38-.895-2.663-1.203-1.37-.329-2.46-.763-3.201-1.355C7.398 10.486 7 9.76 7 8.77c0-1.596 1.283-2.727 3.106-3.121l.394-.086V3.5h2v2.083l.382.093c1.643.4 2.543 1.525 2.773 2.824h-1.208c-.093-.524-.308-1.008-.71-1.384-.521-.486-1.274-.716-2.237-.716-.913 0-1.699.204-2.271.607C8.642 7.42 8.3 8.031 8.3 8.75c0 .304.06.602.206.884.146.281.364.52.645.728.548.405 1.376.724 2.523 1.022 1.126.293 2.219.663 3.027 1.272C15.48 13.243 16 14.053 16 15.3c0 .884-.328 1.547-.859 2.038-.542.503-1.32.847-2.234 1.02l-.407.078V20.5h-2v-1.67z",
		stroke: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M14.5 15l2-2v1.5H22v1h-5.5V17l-2-2zM22 19.5l-2 2V20h-5.5v-1H20v-1.5l2 2z",
		strokeWidth: .5
	})]
});
export { SvgPayments as ReactComponent };
